export default __webpack_public_path__ + "static/media/power-bi.4bc68a8c.png";